import { TAB } from './tab.enum'

export const mapTabEnum = (enumerable: typeof TAB, fn: Function): TAB[] => {
  const enumMembers = Object.keys(enumerable).map((key: string | TAB) => enumerable[key as TAB])

  const enumValues = enumMembers.filter(v => typeof v === 'string')

  return enumValues.map(m => fn(m))
}

export const humanize = (str: string): string => {
  const unhuman = str.split('_')

  for (let i = 0; i < unhuman.length; i++) {
    unhuman[i] = unhuman[i].charAt(0).toUpperCase() + unhuman[i].slice(1)
  }
  return unhuman.join(' ')
}
